import clsx from "clsx";
import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkGfm from "remark-gfm";

type TTMarkdownContentProps = {
  children: string;
  className?: string;
};

const ALLOWED = ["image/png", "image/jpeg", "image/gif", "image/webp"];

function isAllowedDataImage(url: string) {
  if (!url.startsWith("data:")) return false;

  const comma = url.indexOf(",");
  if (comma === -1) return false;

  const meta = url.slice(5, comma);
  const mime = meta.split(";")[0].trim().toLowerCase();

  if (url.length > 2_000_000) return false;

  return ALLOWED.includes(mime);
}

const allowDataImages: Parameters<typeof ReactMarkdown>[0]["urlTransform"] = (url, key, node) => {
  if (key === "src" && node.tagName === "img" && isAllowedDataImage(url)) {
    return url;
  }

  return defaultUrlTransform(url);
};

const schema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames ?? []), "u"],
};

export function TTMarkdownContent({ children, className }: TTMarkdownContentProps) {
  return (
    <div className={clsx("TT-markdown-content", className)}>
      <ReactMarkdown
        urlTransform={allowDataImages}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, schema]]}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
